import React from "react";
import { Star, ExternalLink } from "lucide-react";
import { useContent } from "@/lib/useContent";

const GoogleG = () => (
  <svg viewBox="0 0 48 48" className="w-9 h-9" aria-hidden>
    <path fill="#FFC107" d="M43.6 20.1H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3l5.7-5.7C34.3 6.1 29.4 4 24 4 13 4 4 13 4 24s9 20 20 20 20-9 20-20c0-1.3-.1-2.6-.4-3.9z"/>
    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3l5.7-5.7C34.3 6.1 29.4 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/>
    <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z"/>
    <path fill="#1976D2" d="M43.6 20.1H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C36.9 39.2 44 34 44 24c0-1.3-.1-2.6-.4-3.9z"/>
  </svg>
);

export const GoogleReviews = () => {
  const g = useContent("google_reviews") || {};
  const rating = Number(g.rating) || 4.9;
  return (
    <section className="py-14 bg-white border-y border-[#E5E7EB]" data-testid="google-reviews-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-12 text-center sm:text-left">
        <div className="flex items-center gap-4">
          <GoogleG />
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-[#4B5563] font-bold">Google Reviews</div>
            <div className="flex items-center gap-2 mt-1">
              <span className="font-serif-display text-3xl text-[#0A2E4D]" data-testid="google-rating">{rating.toFixed(1)}</span>
              <div className="flex gap-0.5">{[0,1,2,3,4].map((i) => <Star key={i} size={16} className={i < Math.round(rating) ? "text-[#FBBC05] fill-[#FBBC05]" : "text-[#E5E7EB]"} />)}</div>
            </div>
          </div>
        </div>
        <div className="hidden sm:block w-px h-12 bg-[#E5E7EB]" />
        <p className="text-sm text-[#4B5563] max-w-xs">Rated excellent by {g.count || 120}+ verified travellers across our three global offices.</p>
        <a href={g.link || "#"} target="_blank" rel="noreferrer"
           className="inline-flex items-center gap-2 rounded-full border-2 border-[#0A2E4D] text-[#0A2E4D] hover:bg-[#0A2E4D] hover:text-white px-6 py-2.5 text-sm font-semibold transition-colors"
           data-testid="google-reviews-link">
          See all reviews <ExternalLink size={14} />
        </a>
      </div>
    </section>
  );
};
